export const textLang1: any = {
    jp: {
        descPoints1: '再チェックインするには、',
        descPoints2: 'ポイントが差し引かれます。',
    },
    us: {
        descPoints1: 'This make-up check-in will deduct ',
        descPoints2: ' EcoCredits from you.',
    },
    ca: {
        descPoints1: 'This make-up check-in will deduct ',
        descPoints2: ' EcoCredits from you.',
    },
    au: {
        descPoints1: 'This make-up check-in will deduct ',
        descPoints2: ' EcoCredits from you.',
    },
    eu: {
        descPoints1: 'This make-up check-in will deduct ',
        descPoints2: ' EcoCredits from you.',
    },
    uk: {
        descPoints1: 'This make-up check-in will deduct ',
        descPoints2: ' EcoCredits from you.',
    },
    de: {
        descPoints1: 'Bei diesem Wiederherstellungs-Check-in werden Ihnen ',
        descPoints2: ' EcoCredits abgezogen.',
    },
    es: {
        descPoints1: 'Esta recuperación de visitas te restará ',
        descPoints2: ' EcoCredits.',
    },
    fr: {
        descPoints1: 'Cette confirmation de présence manquée vous coûtera ',
        descPoints2: ' EcoCredits.',
    },
    it: {
        descPoints1: 'Per il recupero di questo check-in ti verranno detratti ',
        descPoints2: ' EcoCredits.',
    },
    kr: {
        descPoints1: '이 체크인 보충으로 ',
        descPoints2: ' EcoCredits가 공제됩니다.',
    },
    za: {
        descPoints1: 'This make-up check-in will deduct ',
        descPoints2: ' EcoCredits from you.',
    },
    br: {
        descPoints1: 'Esta compensação de check-in deduzirá ',
        descPoints2: ' EcoCredits de você.',
    },
    mx: {
        descPoints1: 'Este registro de recuperación descontará ',
        descPoints2: ' EcoCréditos de tu cuenta.',
    },
    ph: {
        descPoints1: 'This make-up check-in will deduct ',
        descPoints2: ' EcoCredits from you.',
    },
};
